import {
  ViewMapper,
  ViewGroupMapper,
  SearchQueryMapper,
} from "features/planner/planner.mappers";

import Agent from "infrastructure/agent";
import { SEARCH_OBJECT_TYPES } from "features/planner/planner.constants";

/**
 * View
 */
const getViews = () => Agent.get(`/view`);

const getView = viewId => Agent.get(`/view/${viewId}`);

const createView = view => Agent.post(`/view`, ViewMapper.to(view));

const updateView = (viewId, view) =>
  Agent.put(`/view/${viewId}`, ViewMapper.to(view));

const deleteView = viewId => Agent.delete(`/view/${viewId}`);

const getUserDefaultView = () => Agent.get("/view/default");

const setUserDefaultViewId = viewId => Agent.post(`/view/default/${viewId}`);

const searchView = (viewId, term, objectTypes = SEARCH_OBJECT_TYPES.ALL) =>
  Agent.get(
    `/view/${viewId}/search`,
    SearchQueryMapper.to({ term, objectTypes }),
  );

const getViewCompetencyStatuses = viewId =>
  Agent.get(`/view/${viewId}/competencystatus`);

const getAvailableGroupsByView = viewId =>
  Agent.get(`/view/${viewId}/groups/available`);

/**
 * ViewGroup
 */
const getViewGroup = (viewId, viewGroupId) =>
  Agent.get(`/view/${viewId}/viewgroups/${viewGroupId}`);

const createViewGroups = (viewId, groupIds) =>
  Agent.post(`/view/${viewId}/viewgroups`, groupIds);

const updateViewGroup = (viewId, viewGroupId, viewGroup) =>
  Agent.put(
    `/view/${viewId}/viewgroups/${viewGroupId}`,
    ViewGroupMapper.to(viewGroup),
  );

const deleteViewGroup = (viewId, viewGroupId) =>
  Agent.delete(`/view/${viewId}/viewgroups/${viewGroupId}`);

const updateViewGroupOrder = (viewId, view) =>
  Agent.put(`/view/${viewId}/order`, ViewMapper.to(view));

const getViewProjects = viewId => Agent.get(`/project/view/${viewId}`);
const getGroupProjects = groupId => Agent.get(`/project/group/${groupId}`);

export default {
  getView,
  getViews,
  createView,
  searchView,
  deleteView,
  updateView,
  getViewGroup,
  updateViewGroup,
  createViewGroups,
  deleteViewGroup,
  getUserDefaultView,
  setUserDefaultViewId,
  updateViewGroupOrder,
  getViewCompetencyStatuses,
  getAvailableGroupsByView,
  getViewProjects,
  getGroupProjects,
};
